// ProductModal.jsx
const ProductModal = ({ product, onClose }) => {
  if (!product) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={product.image} alt={product.title} className="modal-image" />

        <div className="modal-info">
          <h2>{product.title}</h2>
          <p className="modal-price">{product.price}</p>
        </div>

        <button className="modal-close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default ProductModal;
